export const SUBSCRIPTION_STATUS = {
    IMCOMPLETE: 'incomplete',
    IMCOMPLETE_EXPIRED: 'incomplete_expired',
    TRIALING: 'trialing',
    ACTIVE: 'active',
    PAST_DUE: 'past_due',
    CANCELED: 'canceled',
    UNPAID: 'unpaid'
}